import React from "react"
import Select, {StylesConfig} from "react-select"
import {UsNexusTypeMapping} from "../../../resources/application"
import Dropdown from "../../Address/Dropdown"

interface UsNexusOption {
	readonly value: string
	readonly label: string
}

const usNexusOptions: UsNexusOption[] = Array.from(UsNexusTypeMapping.entries()).map(([value, label]) => ({
	value,
	label,
}))

const selectStyles: StylesConfig<UsNexusOption, true> = {
	control: (base, state) => ({
		...base,
		borderColor: state.isFocused ? "#000000" : base.borderColor,
		"&:hover": {
			borderColor: state.isFocused ? "#000000" : base.borderColor,
		},
		minHeight: 52,
		marginTop: 8,
	}),
	container: (base) => ({
		...base,
		width: "100%",
	}),
}

interface UsNexusFormFieldProps {
	value: string[] | undefined
	onChange: (value: string[] | undefined) => void
	onBlur: (e: React.FocusEvent<HTMLSelectElement>) => void
}

export default function UsNexusFormField({value, onChange, onBlur}: UsNexusFormFieldProps) {
	const hasUsNexus = value === undefined ? "" : value.includes("NotAvailable") ? "no" : "yes"

	const handleHasUsNexusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const val = e.target.value
		if (val === "no") {
			onChange(["NotAvailable"])
		} else if (val === "yes") {
			onChange([])
		} else {
			onChange(undefined)
		}
	}

	const handleSelectChange = (newValue: readonly UsNexusOption[]) => {
		if (newValue.length === 0) {
			onChange([])
		} else {
			onChange(newValue.map((v) => v.value))
		}
	}

	const selectedOptions = usNexusOptions.filter((o) => value?.includes(o.value))

	return (
		<div className="double-column-field us-nexus-field">
			<Dropdown
				name="hasUsNexus"
				label="Has US Nexus"
				value={hasUsNexus}
				onChange={handleHasUsNexusChange}
				onBlur={onBlur}
			>
				<option value="" />
				<option value="yes">Yes</option>
				<option value="no">No</option>
			</Dropdown>
			{value !== undefined && !value.includes("NotAvailable") && (
				<div className="us-nexus-select">
					<label className="label-text" htmlFor="usNexus">
						US Nexus Types
					</label>
					<Select<UsNexusOption, true>
						id="usNexus"
						isMulti
						value={selectedOptions}
						options={usNexusOptions}
						onChange={handleSelectChange}
						styles={selectStyles}
						placeholder="Select US Nexus types..."
						closeMenuOnSelect={false}
						hideSelectedOptions={false}
						menuPlacement="auto"
					/>
				</div>
			)}
		</div>
	)
}
